<template>
  <v-container fluid class="my-5">
    <MesaDirectivaReunionDetalle />
  </v-container>
</template>

<script>
import MesaDirectivaReunionDetalle from '@/components/mesaDirectiva/MesaDirectivaReunionDetalle.vue'

export default {
  name: 'mesa_directiva_reunion_detalle',
  components: {
    MesaDirectivaReunionDetalle
  }
}
</script>
